
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-dayjs/-embroider-implicit-modules.js";
import "ember-resources/-embroider-implicit-modules.js";
import "ember-config-service/-embroider-implicit-modules.js";
